import { useEffect } from 'react';

export type LiveSignal = 'bookings-changed' | 'messages-changed';

/** Reloads when the app comes back on screen, every `everyMs` while it is visible, and when a notification of that kind arrives. */
export function useLiveRefresh(load: () => void, opts: { everyMs?: number; on?: LiveSignal } = {}) {
  const everyMs = opts.everyMs ?? 60_000;
  const on = opts.on ?? 'bookings-changed';
  useEffect(() => {
    load();
    const visible = () => document.visibilityState === 'visible';
    const onVisible = () => visible() && load();
    const onMessage = (e: MessageEvent) => (e.data as { type?: string } | null)?.type === on && load();
    const timer = setInterval(() => visible() && load(), everyMs);
    document.addEventListener('visibilitychange', onVisible);
    navigator.serviceWorker?.addEventListener('message', onMessage);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
      navigator.serviceWorker?.removeEventListener('message', onMessage);
    };
  }, [load, everyMs, on]);
}
